import { useTranslation } from '@sib/i18n';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  FormCheckbox,
  FormPhoneInput,
} from '@sib/ui';
import { BaseDialogForm } from '@spendbrain/common';
import {
  PhoneNumberFormField,
  usePhoneNumberForm,
} from './PhoneNumberModal.utils';

interface PhoneNumberModalProps {
  open: boolean;
  userId: string;
  onSuccess: (statusUpdated: boolean) => void;
}

export const PhoneNumberModal = ({
  open,
  userId,
  onSuccess,
}: PhoneNumberModalProps) => {
  const { t } = useTranslation();

  const { formProps, onSubmit, isPending } = usePhoneNumberForm({
    userId,
    onSuccess,
  });

  const dontAskAgain = formProps.watch(PhoneNumberFormField.DontAskAgain);

  return (
    <Dialog open={open}>
      <DialogContent className="md:max-w-[717px] lg:max-w-[817px] lg:px-32">
        <DialogHeader className="flex flex-col gap-4">
          <DialogTitle className="text-primary flex justify-center text-xl">
            {t('phoneNumberModal.title')}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground">
            {t('phoneNumberModal.description')}
          </DialogDescription>
        </DialogHeader>
        <BaseDialogForm
          onSubmit={onSubmit}
          SubmitButtonProps={{
            text: t('phoneNumberModal.continue'),
            disabled: isPending,
          }}
          className="py-4"
          {...formProps}
        >
          <FormPhoneInput
            name={PhoneNumberFormField.PhoneNumber}
            placeholder={t('phoneNumberModal.placeholder')}
            disabled={isPending || dontAskAgain}
            defaultCountry="US"
            countrySearchPlaceholder={t('phoneNumberModal.searchCountry')}
            countryNotFoundText={t('phoneNumberModal.noCountryFound')}
          />
          <div className="py-6">
            <FormCheckbox
              name={PhoneNumberFormField.DontAskAgain}
              label={t('phoneNumberModal.dontAskAgain')}
              disabled={isPending}
            />
          </div>
        </BaseDialogForm>
      </DialogContent>
    </Dialog>
  );
};
